/*
* CatalogEditReducer
*/

import { fromJS } from 'immutable';
import {
  SET_LOADING,
  EDIT_OFFER,
  DELETE_OFFER,
  REQUEST_SUCCESS_RESPONSE,
  REQUEST_ERROR_RESPONSE,
  GET_OFFER,
  OFFER_RECEIVED,
  REDIRECT_TO_PAGE,
  RESET,
} from './constants';

// The initial state of the App
export const initialState = fromJS({
  response: null,
  code: null,
  id: null,
  loading: false,
  redirect: false,
  error: null,
});

function catalogEditReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return state.set('loading', action.loading);
    case EDIT_OFFER:
    case DELETE_OFFER:
      return state.set('loading', true);
    case GET_OFFER:
      return state.set('code', action.code).set('loading', true);
    case OFFER_RECEIVED:
      return state.set('id', action.id).set('loading', false);
    case REQUEST_SUCCESS_RESPONSE:
      return state
        .set('loading', false)
        .set('response', action.response)
        .set('code', action.response.code || null);
    case REQUEST_ERROR_RESPONSE:
      return state.set('loading', false).set('error', action.response);
    case REDIRECT_TO_PAGE:
      return state.set('redirect', action.redirect);
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default catalogEditReducer;
